import { axiosInstanceCert } from "../axios";
import { CertificateUploadData, RequestResponse } from "../types";

export const uploadCertificate: (
  data: CertificateUploadData
) => Promise<RequestResponse> = async _data => {
  try {
    const data = new FormData();
    Object.entries(_data).forEach(([key, value]) => data.append(key, value));
    await axiosInstanceCert.post("/save", data);
    return { error: false, data: null };
  } catch (error) {
    console.log("Error uploading certificate: ", error);
    return {
      error: true,
      message: error?.response?.data?.errorMessage || error.message,
      data: null
    };
  }
};
